<template>
  <div class="list-header-nav">
    <div class="list-header-nav__box" ref="box">
      <ol class="breadcrumb">
        <li v-for="(item,index) in innerCrumbs" :key="`crumb-${index}`" :title="getCrumbName(item)">
          <a href="javascript:void(0)" @click="jumpToCrumb(item, index)">{{getCrumbName(item)}}</a>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { getInnerProps } from 'tools/utils';

export default {
  model: {
    prop: 'crumbs',
    event: 'update:crumbs',
  },
  props: {
    crumbs: Array,
  },
  computed: {
    innerCrumbs: getInnerProps('crumbs'),
  },
  methods: {
    initCrumbs() {
      this.innerCrumbs = [{ name: 'root', flag: 'root' }];
    },
    jumpToCrumb(item, index) {
      this.innerCrumbs.splice(index + 1);
    },
    getCrumbName(item) {
      // 如果是根目录,返回国际化文本,否则返回原始名称
      return item.flag === 'root' ? this.$t('cos.all_files') : item.name;
    },
  },
};
</script>

<style lang="scss" scoped>
.list-header-nav {
  border: 0;
}
.breadcrumb {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}
</style>
